import { ReactNode, useEffect, useState } from "react";

import { Box, CircularProgress } from "@mui/material";

export default function ConfiguratorLoadingCurtain(): ReactNode {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 3000);
    return () => {
      setIsOpen(true);
    };
  }, []);

  if (!isOpen) {
    return <></>;
  }
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        position: "absolute",
        zIndex: "10",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        pt: 4,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
